/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Entry_Price__Before_StartInputs */

const en_help_center__refund_policy__entry_price__before_start = /** @type {((inputs: Help_Center__Refund_Policy__Entry_Price__Before_StartInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Entry_Price__Before_StartInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Entry_Price__Before_StartInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Before Battle Starts: If you join a battle and it doesn't fill up within a reasonable timeframe, you will receive a full refund of your entry price.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Entry_Price__Before_StartInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Before Battle Starts:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " If you join a battle and it doesn't fill up within a reasonable timeframe, you will receive a " }, { type: "markup-start", name: "strong", options: {}, attributes: { "primary": true } }, { type: "text", value: "full refund of your entry price" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Before Battle Starts: If you join a battle and it doesn't fill up within a reasonable timeframe, you will receive a full refund of your entry price." |
*
* @param {Help_Center__Refund_Policy__Entry_Price__Before_StartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__entry_price__before_start = /** @type {((inputs?: Help_Center__Refund_Policy__Entry_Price__Before_StartInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Entry_Price__Before_StartInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Entry_Price__Before_StartInputs, { locale?: "en" }, { strong: { options: {}; attributes: { primary?: true }; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Entry_Price__Before_StartInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__entry_price__before_start(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Entry_Price__Before_StartInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__entry_price__before_start.parts === "function" ? en_help_center__refund_policy__entry_price__before_start.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__entry_price__before_start(inputs) }]
			})
		}
	)
);